import { fetch as apiFetch, postData, putData, deleteFunction } from "../../../Component/function/FunctionApi"; 

const BASE = "Expense";

export const expenseService = {
  getExpenses: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.from) params.append("From", filters.from);
    if (filters.to) params.append("To", filters.to);
    if (filters.expenseType) params.append("ExpenseType", filters.expenseType);
    if (filters.employeeId) params.append("EmployeeId", filters.employeeId);
    const query = params.toString();
    return apiFetch(query ? `${BASE}?${query}` : BASE);
  },
  getExpenseById: (id) => apiFetch(`${BASE}/${id}`),
  addExpense: (data) => postData(BASE, data),
  updateExpense: (id, data) => putData(`${BASE}/${id}`, data),
  deleteExpense: (id) => deleteFunction(`${BASE}/${id}`),
};